import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

export default function Link({ children, className, to }) {
  if (to.startsWith('/')) {
    return (
      <GatsbyLink
        className={['link'].concat(className || []).join(' ')}
        to={to}
      >
        {children}
      </GatsbyLink>
    )
  } else if (to) {
    return (
      <a
        className={['link'].concat(className || []).join(' ')}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    )
  }

  return (
    <span className={['link'].concat(className || []).join(' ')}>
      {children}
    </span>
  )
}
